import { initTagManager, sendEvent } from '@skyscanner-internal/gtm-client';

import getFeatureDecision from './config';
import {
  ENABLE_GTM,
  ENABLE_MONTH_VIEW_GTM_INTEGRATION,
} from './config/constants';
import { GTM_EVENT_NAME } from './constants';

const isGtmEnabled = () =>
  getFeatureDecision(ENABLE_MONTH_VIEW_GTM_INTEGRATION, false) &&
  getFeatureDecision(ENABLE_GTM, false);

const initGtmClient = () => {
  if (!isGtmEnabled()) return;
  const { gtmDataLayer } = window.__internal;
  initTagManager(gtmDataLayer.market);
};

const sendTaggingEvent = (extraProps = {}) => {
  if (!isGtmEnabled()) return;
  const { gtmDataLayer } = window.__internal;
  const eventData = {
    event: GTM_EVENT_NAME,
    ...gtmDataLayer,
    ...extraProps,
  };
  sendEvent(eventData);
};

export { initGtmClient, sendTaggingEvent };
